import domain from './domain';

// Reset teams
export const resetTeams = domain.createEvent('resetTeams');

// Reset team occupancy
export const resetTeamOccupancy = domain.createEvent('resetTeamOccupancy');
